import React from 'react'
import { gql } from '@apollo/client'
import { useMutation } from '@ztechapps/common.hook'
import type { UseCommonCartProps } from '../type'
import type { AddToCartArgs, Order, Product } from '@ztechapps/common.contract'
import type { PartialDeep } from 'type-fest'
import { orderFragment } from '../../graphql'

export const buildOrderAddToCartQuery = (fragment: string) => {
  return gql`
  mutation orderAddToCart($input: AddToCartArgs!) {
    orderAddToCart(input: $input) {
        _id
       ${fragment}
    }
  }
`
}

export const addToCartQuery = gql`
  ${orderFragment}
  mutation orderAddToCart($input: AddToCartArgs!) {
    orderAddToCart(input: $input) {
      ...orderFragment
    }
  }
`

export const useAddToCart = ({ validate, query, ...rest }: UseCommonCartProps = {}) => {
  const [onAdd, , { loading, error }] = useMutation<{ orderAddToCart: Order }, AddToCartArgs>({
    query: query ?? addToCartQuery,
    ...rest,
  })

  const addToCart = React.useCallback(
    ({
      product,
      orderId,
      quantity,
      remarks,
    }: {
      product: PartialDeep<Product>
      orderId?: string
      quantity: number
      remarks?: string
    }) => {
      validate?.()

      //do the submission here
      const input = {
        orderId,
        quantity,
        remarks,
        product: {
          _id: product._id,
          code: product.code,
        },
      } as AddToCartArgs

      return onAdd({ input })
    },
    [onAdd, validate]
  )

  return { addToCart, loading, error }
}
